
import Home from "../pages/public/Home.vue";

export default [
  // HOME - eager loaded
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      layout: "public",
      title: "Accueil",
    },
  },

  // CONTACT - public for everyone
  {
    path: "/contact",
    name: "contact",
    component: () => import("../pages/public/Contact.vue"),
    meta: {
      layout: "public",
      title: "Contact",
    },
  },

  // BRANDS
  {
    path: "/marques",
    name: "brands",
    component: () => import("../pages/public/Brands.vue"),
    meta: {
      layout: "public",
      title: "Nos marques",
    },
  },

  {
    path: "/brands",
    name: "brands",
    component: () => import("../pages/public/Brands.vue"),
    meta: {
      layout: "public",
      title: "Marques de pneus | ProduPneu",
    },
  },
  {
    path: "/marques",
    redirect: { name: "brands" },
  },

  // MOUNTING & DELIVERY
  {
    path: "/montage/livraison",
    name: "delivery",
    component: () => import("../pages/public/Delivery.vue"),
    meta: {
      layout: "public",
      title: "Montage et livraison",
    },
  },

  // PRODUCTS
  {
    path: "/products",
    name: "products",
    component: () => import("../pages/public/ProductList.vue"),
    meta: {
      layout: "public",
      title: "Nos pneus",
    },
  },
  // Show PRODUCTS
  {
    path: "/products/:id",
    name: "product.show",
    component: () => import("../pages/public/ProductDetails.vue"),
    props: true,
    meta: {
      layout: "public",
      title: "Détails du pneu",
    },
  },

  // CART
  {
    path: "/cart",
    name: "cart",
    component: () => import("../pages/public/Cart.vue"),
    meta: {
      layout: "public",
      title: "Mon panier",
    },
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("../pages/public/Checkout.vue"),
    meta: {
      layout: "public",
      title: "Finaliser ma commande | ProduPneu",
    },
  },
  {
    path: "/delivery",
    name: "delivery",
    component: () => import("../pages/public/Delivery.vue"),
    meta: {
      layout: "public",
      title: "Livraison et montage de pneus | ProduPneu",
    },
  },
  {
    path: "/montage/livraison",
    redirect: { name: "delivery" },
  },

  // LOGIN
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/Login.vue"),
    meta: {
      layout: "public",
      guestOnly: true,
      title: "Connexion",
    },
  },

  // REGISTER
  {
    path: "/register",
    name: "register",
    component: () => import("../pages/Register.vue"),
    meta: {
      layout: "public",
      guestOnly: true,
      title: "Créer un compte",
    },
  },
];
